<template>
	<div>
		<el-drawer size="800px" :show-close="false" :visible="detailVisible" :before-close="closeDlg">
		<template slot="title">
			<div class="el-drawer-close" @click="closeDlg"><i class="el-icon el-icon-arrow-left"></i>返回</div>
			<div>评估详情</div>
			<div class="eval-history-list" @click="viewHistoryList">历史评估</div>
		</template>
		<div class="drawer-content" v-if="!viewHisQuest">
			<el-steps align-center :active="current" finish-status="success">
				<el-step title="数据采集"></el-step>
				<el-step title="评估报告"></el-step>
			</el-steps>

			<div class="step-1" v-if="current === 0">

				<div class="step-title" v-for="item in questList" :key="item.id">
					<div>
						{{ item.name }}
						<el-tag v-if="item.finishTime" size="mini" style="margin-left: 10px">已完成</el-tag>
						<el-tag v-else type="info" size="mini" style="margin-left: 10px">未完成</el-tag>
					</div>
					
					<!-- <div class="hisQuest" @click="viewHisQuest=true">
						<img src="../../../../../assets/images/history-fill.png" alt="" srcset="">
						历史问卷
					</div> -->
					<router-link class="el-link el-link--primary" target="_blank" :to="{name: 'QuestForm', params: {key: item.qcId}, query: { rid: item.id, t: my.token }}">
						<i class="icon-research"></i>
						<span style="padding-left: 4px;">{{ item.finishTime?'查看问卷':'填写问卷' }}</span>
					</router-link>
					<!-- <el-link type="primary" icon="icon-research" :underline="false"></el-link> -->
				</div>

				<div class="step-content">
					<!-- 入院评估 -->
					<EvalDetail4 v-if="customerEval.type == '4'" :questSucc="questSucc" :id="id" :patientId="patientId" :otherData= "customerEval.otherData" @succ="onAssessSucc" />
					<!-- 饮食 -->
					<EvalDetail6 v-else-if="customerEval.type == '6'" :questSucc="questSucc" :id="id" :patientId="patientId" :otherData= "customerEval.otherData" @succ="onAssessSucc" />					
					<!-- 睡眠 -->
					<EvalDetail7 v-else-if="customerEval.type == '7'" :questSucc="questSucc" :id="id" :patientId="patientId" :otherData= "customerEval.otherData" @succ="onAssessSucc" />
					<!-- 其他（心理，中医，运动风险） -->
					<EvalDetail2 v-else :questSucc="questSucc" :id="id" :patientId="patientId" :otherData= "customerEval.otherData" @succ="onAssessSucc" />
					
					<!-- <div class="exam-item">
						<div class="item-name">
							心电图
							<el-tooltip content="介绍内容" placement="top" :enterable="false"><i class="el-icon-warning"></i></el-tooltip>
						</div>
						<el-checkbox-group v-model="form.sv">
							<div class="opt-item">
								<el-checkbox style="width: 220px;" :label="1">SV1+Rv5 (Sokolow-Lvonth#)</el-checkbox>
								<el-input size="small" maxlength="6" style="width: 120px" v-model.trim="form.sv_value"></el-input>mm
							</div>
							<div class="opt-item">
								<el-checkbox style="width: 220px;" :label="2">RavL+Sv3 (Cornel指数)</el-checkbox>
								<el-input size="small" maxlength="6" style="width: 120px" v-model.trim="form.sv_value"></el-input>mm.mms
							</div>
							<div class="opt-item">
								<el-checkbox style="width: 220px;" :label="3">左心室肥厚</el-checkbox>
							</div>
						</el-checkbox-group>
					</div>

					<div class="exam-item">
						<div class="item-name">
							超声心动图
							<el-tooltip content="介绍内容" placement="top" :enterable="false"><i class="el-icon-warning"></i></el-tooltip>
						</div>
						<el-checkbox-group v-model="form.sv">
							<div class="opt-item">
								<el-checkbox style="width: 220px;" :label="1">LVMI（左心室质量指数）</el-checkbox>
								<el-input size="small" maxlength="6" style="width: 120px" v-model.trim="form.sv_value"></el-input>g/m2
							</div>
							<div class="opt-item">
								<el-checkbox style="width: 220px;" :label="2">左心室肥厚</el-checkbox>
							</div>
						</el-checkbox-group>
					</div>

					<div class="exam-item">
						<div class="item-name">
							颈动脉超声
							<el-tooltip content="介绍内容" placement="top" :enterable="false"><i class="el-icon-warning"></i></el-tooltip>
						</div>
						<el-checkbox-group v-model="form.sv">
							<div class="opt-item">
								<el-checkbox :label="1">MIMT</el-checkbox>
								<el-input size="small" maxlength="6" style="width: 120px" v-model.trim="form.sv_value"></el-input>mm

								<el-checkbox style="margin: 0 30px 0 20px;" :label="2">颈动脉斑块</el-checkbox>
								<el-checkbox :label="3">颈动脉内中膜增厚</el-checkbox>
							</div>
						</el-checkbox-group>
					</div>

					<div class="exam-item">
						<div class="item-name">
							血肌酐（肾功能）
							<el-tooltip content="介绍内容" placement="top" :enterable="false"><i class="el-icon-warning"></i></el-tooltip>

							<div class="date">检验时间：2022/05/01 12:11</div>
						</div>
						<el-radio-group v-model="form.sv">
							<div class="opt-item">
								<el-radio style="width: 220px;" :label="1">
									<el-input size="small" maxlength="6" style="width: 120px; margin-left: 0;" v-model.trim="form.sv_value"></el-input>mmol/L
								</el-radio>
								<el-radio style="width: 220px;" :label="2">
									<el-input size="small" maxlength="6" style="width: 120px; margin-left: 0;" v-model.trim="form.sv_value"></el-input>md/dL
								</el-radio>
							</div>
						</el-radio-group>
					</div>

					<div class="exam-item">
						<div class="item-name">
							尿微量白蛋白
							<el-tooltip content="介绍内容" placement="top" :enterable="false"><i class="el-icon-warning"></i></el-tooltip>

							<div class="date">检验时间：2022/05/01 12:11</div>
						</div>
						<el-input size="small" maxlength="6" style="width: 120px; margin: 0 5px 0 2em;" v-model.trim="form.sv_value"></el-input>mg/24h
					</div>

					<div class="exam-item">
						<div class="item-name">
							白蛋白/肌酐
							<el-tooltip content="介绍内容" placement="top" :enterable="false"><i class="el-icon-warning"></i></el-tooltip>
						</div>
						<el-input size="small" maxlength="6" style="width: 120px; margin: 0 5px 0 2em;" v-model.trim="form.sv_value"></el-input>ma/g
					</div>


					<div class="exam-item">
						<div class="item-name">
							眼底照像
							<el-tooltip content="介绍内容" placement="top" :enterable="false"><i class="el-icon-warning"></i></el-tooltip>
						</div>
						<el-checkbox-group v-model="form.sv">
							<div class="opt-item">
								<el-checkbox :label="1">视网膜出血</el-checkbox>

								<el-checkbox style="margin: 0 30px 0 20px;" :label="2">微动脉瘤</el-checkbox>
								<el-checkbox :label="3">视乳头水肿</el-checkbox>
							</div>
						</el-checkbox-group>
					</div>
					


					<div class="exam-item">
						<div class="item-name">
							头颅MRI
							<el-tooltip content="介绍内容" placement="top" :enterable="false"><i class="el-icon-success"></i></el-tooltip>

							<div class="date">检验时间：2022/05/01 12:11</div>
						</div>
						<el-checkbox-group v-model="form.sv">
							<div class="opt-item">
								<el-checkbox :label="1">脑白质病娈</el-checkbox>
								<el-checkbox style="margin: 0 30px 0 20px;" :label="2">无症状脑梗死</el-checkbox>
								<el-checkbox :label="3">微出血</el-checkbox>
								<el-checkbox :label="4">脑萎缩</el-checkbox>
							</div>
						</el-checkbox-group>
					</div> -->

					<!-- <div style=" padding: 20px 0; color: #FF6C6C; font-size: 12px;text-align: center;">数据未采集全，无法评估</div> -->


				</div>
			</div>
			<div  v-if="current === 2">
				<div class="sub-title" v-for="item in questList" :key="item.id">
					<div>
						{{ item.name }}
						<el-tag v-if="item.finishTime" size="mini" style="margin-left: 10px">已完成</el-tag>
						<el-tag v-else type="info" size="mini" style="margin-left: 10px">未完成</el-tag>
					</div>
					<!-- <div class="hisQuest"  @click="viewHisQuest=true">
						<img src="../../../../../assets/images/history-fill.png" alt="" srcset="">
						历史问卷
					</div> -->
					<router-link class="el-link el-link--primary" target="_blank" :to="{name: 'QuestForm', params: {key: item.qcId}, query: { rid: item.id, t: my.token }}">
						<i class="icon-research"></i>
						<span style="padding-left: 4px;">{{ item.finishTime?'查看问卷':'填写问卷' }}</span>
					</router-link>
					<!-- <el-link type="primary" icon="icon-research" :underline="false"></el-link> -->
				</div>
			</div>
			<div v-if="current === 2" style="position: relative; margin: 30px 30px -30px; z-index: 2;">
				<el-button type="primary" size="mini" round @click="exportPdf">打印报告</el-button>
				<p v-if="pushState==1" style="float:right; color:#699CE4">评估已推送</p>
				<el-button v-if="pushState!==1" style="float:right;" size="mini" round @click="dialogVisible=true">
					推送报告
				</el-button>
			</div>
			<div class="step-2" v-if="current === 2">
				<div class="step-title">
					<div>{{ evalResult.name }}</div>
					<div v-if="recordId||datasources" style="font-size: 14px;font-weight: normal;margin-top: 8px;">姓名：{{ medicalRecordDetail.patientName}}&nbsp;&nbsp;&nbsp;&nbsp;科室：{{ medicalRecordDetail.department}}&nbsp;&nbsp;&nbsp;&nbsp;床号：{{medicalRecordDetail.inpatientArea}}-{{ medicalRecordDetail.hospitalBed}}床</div>
					<div style="font-size: 14px;font-weight: normal;margin-top: 8px;n">评估完成时间：{{customerEval.updateTime }}&nbsp;&nbsp;&nbsp;&nbsp;创建人：{{customerEval.creatorName}}</div>
				</div>
				<div v-if="evalResult.other.subtitle" v-html="evalResult.other.subtitle" style="white-space: pre-wrap;line-height: 1.8em; padding: 10px 20px; border:1px solid #699CE4; border-radius: 5px; background:#F3F8FF; font-size: 16px;"></div>
				<h3>评估结果</h3>
				<EvalDetail_s2_2 v-if="customerEval.type === '2'" :result="evalResult" />
				<EvalDetail_s2_3 v-else-if="customerEval.type === '3'" :result="evalResult" />
				<EvalDetail_s2_4 v-else-if="customerEval.type === '4'" :result="evalResult" />
				<EvalDetail_s2_5 v-else-if="customerEval.type === '5'" :result="evalResult" />
				<EvalDetail_s2_6 v-else-if="customerEval.type === '6'" :result="evalResult" />
				<EvalDetail_s2_7 v-else-if="customerEval.type === '7'" :result="evalResult" />
				<div v-else style="line-height: 1.8em; font-size: 20px;">{{evalResult.evalContent}}</div>
					<template v-if="evalResult.other?.suggest && evalResult.other?.suggestTitle">
						<h4>{{evalResult.other?.suggestTitle}}</h4>
						<div>
							<p style="line-height: 1.8em; color: #666; text-indent: 2em;" v-for="(item, index) in evalResult.other.suggest" :key="index" v-text="item"></p>
						</div>
					</template>
				<!-- <div style="padding: 0 30px;">
					<div class="item-wrap no-bd">
						<div class="item-title">
							<div class="title2">高血压诊断</div>
							<div class="desc">原发性高血压（未用降压药）</div>
						</div>
					</div>

					<div class="item-wrap no-bd">
						<div class="item-title">
							<div class="title2">血压水平</div>
							<div class="desc">高血压1级</div>
						</div>
					</div>

					<div class="tb-item">
						<div class="title">
							<div>靶器官损害（HMOD）</div>
							<div>并发疾病</div>
						</div>
						<div class="tb-content">
							<div class="c1">
								<div class="img-body"></div>
								<div class="detail">
									<p>脑：脑白质病变</p>
									<p>眼：微动脉瘤</p>
									<p>心：左心室肥厚</p>
									<p>肾：血清肌酐轻度升高</p>
									<p>动脉：颈动脉内中膜增厚</p>
								</div>
							</div>

							<div class="c2">
								<div>
									<p>糖尿病</p>
									<p>心血管疾病：心肌梗死、心绞痛、冠脉血运重建、心力衰竭、房颤</p>
									<p>脑血管疾病：缺血性脑卒中、脑出血、短暂性脑缺血发作</p>
									<p>周围血管病：主动脉瘤、主动脉夹层</p>
									<p>慢性肾脏病：血清肌酐升高、蛋白尿、CKD4</p>
									<p>炎症性风湿病</p>
									<p>慢性阻塞性肺疾病（COPD）</p>
									<p>精神疾病</p>
								</div>	
							</div>
						</div>				
					</div>

					<div class="tb-item tb2">
						<div class="title">
							<div>当前存在的危险因素</div>
						</div>
						<div class="title sub-title">
							<div>高血压危险因素</div>
							<div>心血管危险因素</div>
							<div>加重和诱发高血压的因素（药物）</div>
						</div>
						<div class="tb-content">
							<div>
								<p>高盐膳食习惯</p>
								<p>过量饮酒</p>
								<p>体重增加</p>
								<p>精神压力</p>
								<p>吸烟</p>
								<p>缺乏体力活动</p>
							</div>
							<div>
								<p>年龄＞55岁（男性）或＞65岁（女性）</p>
								<p>吸烟或已戒烟</p>
								<p>体重增加</p>
								<p>早发心血管病家族史</p>
								<p>早发高血压家族史</p>
								<p>糖耐量受损  空腹血糖异常</p>
								<p>血脂异常</p>
								<p>静坐的生活方式</p>
								<p>痛风或高尿酸血症</p>
								<p>早发更年期</p>
								<p>心理及社会经济因素（精神压力）</p>
								<p>心率快</p>
							</div>
							<div>
								<p>高盐膳食习惯</p>
								<p>过量饮酒</p>
								<p>体重增加</p>
								<p>精神压力</p>
								<p>吸烟</p>
								<p>缺乏体力活动</p>
							</div>
						</div>
					</div>

					<div class="item-wrap">
						<div class="item-title">
							<div class="title">心血管危险分层</div>
						</div>
						<div class="item-content">根据本次评估，您目前的心血管疾病危险级别为   低危  中危  高危，提示您在未来10年内脑卒中和心肌梗死的发生概率为  小于15%  15~20%  20%以上。如能按照医生的管理计划对相关风险因素进行管理和改善，可使心血管疾病危险度不断降低，有效预防或延缓重大心脑血管事件的发生。</div>
					</div>
				</div> -->
				<div class="support"><span>双佰康疾病管理系统</span></div>
			</div>

		</div>
		<HistoryQuest v-if="viewHisQuest" :medicalRecordDetail="medicalRecordDetail" :dictId="questList[0].qcId" :evalId="id" :viewHisQuest.sync="viewHisQuest" />
	</el-drawer>
	<div class="dialogWrap" v-if="dialogVisible" >
		<div class="modalmask"></div>
		<SendDialog :dialogVisible.sync="dialogVisible"  :type="customerEval.type" :evalId="id" />
	</div>

	</div>
	
</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api';
import htmlToPdf from '@/service/htmlToPdf';

import EvalDetail2 from './eval-detail-2.vue';
import EvalDetail3 from './eval-detail-3.vue';
import EvalDetail4 from './eval-detail-4.vue';
import EvalDetail5 from './eval-detail-5.vue';
import EvalDetail6 from './eval-detail-6.vue';
import EvalDetail7 from './eval-detail-7.vue';

import EvalDetail_s2_2 from './eval-detail-s2-2.vue';
import EvalDetail_s2_3 from './eval-detail-s2-3.vue';
import EvalDetail_s2_4 from './eval-detail-s2-4.vue';
import EvalDetail_s2_5 from './eval-detail-s2-5.vue';
import EvalDetail_s2_6 from './eval-detail-s2-6.vue';
import EvalDetail_s2_7 from './eval-detail-s2-7.vue';
import SendDialog from './pushEval.vue';
import HistoryQuest from './history-quest.vue';
import { EventBus } from '@/event-bus.js';
// EvalDetail3, EvalDetail5,
export default {  
	mixins: [mixin],
	components: {EvalDetail2,EvalDetail4, EvalDetail6, EvalDetail7, EvalDetail_s2_2, EvalDetail_s2_3, EvalDetail_s2_4, EvalDetail_s2_5, EvalDetail_s2_6, EvalDetail_s2_7,SendDialog,HistoryQuest},
	props: {
		detailVisible: Boolean,
		// 评估id
		id: Number,
		// 评估类型
		type: Number,
		name: String,
		customerId: Number,
	},	
	watch: {
		detailVisible() {
			this.current = 0;
			if (this.detailVisible) {
				this.loadData();
				this.getPushState()
				window.addEventListener('focus', this.loadData);
			} else {
				window.removeEventListener('focus', this.loadData);
			}
		},
		dialogVisible: {
			handler(value) {
				this.getPushState()
			},
			deep: true
		}
	},
	data(){
		return {
			noSidebar: true,
			active: false,
			patientId: 0,
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				pageNumber: 1,
				pageSize: 10
			},
			current: 0,
			questList: undefined,
			evalResult: {other:{riskFactors:[]}},
			customerEval: {},
			questSucc: true,
			recordId:null,
			datasources:null,
			medicalRecordDetail:{},
			dialogVisible:false,
			pushState:0,
			viewHisQuest:false
		}
	},
	created() {this.init();},
	mounted(){
		EventBus.$on('update-viewHisQuest', (newValue) => {
			// console.log(newValue,'===============2222===')
			if(newValue=='sucess'){
				this.loadData();
				this.getPushState()
				this.viewHisQuest=false;
			}
		});
	},
	methods: {
		async init() {
			this.patientId = +this.$route.query.patientId;
			this.recordId=this.$route.query.fid;
			this.datasources=+this.$route.query.datasources;
			this.getPushState();
		},
		// 评估结果
		async loadData() {
			if(this.id<=0) return false;
			let tmpContent;
			// console.log(1111111111111111,this.id)

			const res = await api.getCustomerEval(this.id);
			// const res = await api.getCustomerEval(142);
			
			this.evalResult = {other:{riskFactors:[]}};
			this.customerEval = res.data;
			// 调试用
			// this.customerEval.type = '6';
			if (this.customerEval.evalResult) {
				this.evalResult = JSON.parse(this.customerEval.evalResult.allResult);
				if (this.type === 2) {
					// 辣鸡数据参数，都不统一
					tmpContent = this.evalResult.evalContent;
					this.evalResult.evalContent = this.evalResult.other.criterion?.replace(/\n/ig, '<br/>');
					this.evalResult.other.criterion = tmpContent;
				} else if (this.type === 3) {
					this.evalResult.evalContent = this.evalResult.other.criterion?.replace(/\n/ig, '<br/>');
				} else {
					this.evalResult.evalContent = this.evalResult.evalContent?.replace(/\n/ig, '<br/>');
				}
			}

			this.questSucc = true;
			this.questList = res.data.questionnaireResults;
			
			// 验证问卷是否已完成
			this.questList?.map(item=>{
				if (!item.finishTime) {
					this.questSucc = false;
				}
			})
			if (this.customerEval.finishTime) {
				this.current = 2;
			}
			if(this.recordId||this.datasources){
				let result = await api.getFollowUp({
							recordId: this.recordId,
							datasources: this.datasources
				});
				if(result.code==1000){
					this.medicalRecordDetail=result.data;
				}
				// console.log(this.medicalRecordDetail,'======2222222')
			}
			// this.current = 2;
		},
		closeDlg() {
			this.pushState=null;
			this.viewHisQuest=false;
			this.$emit("update:detailVisible", false);
		},
		viewHistoryList(){
			this.$emit("viewHistory");
			this.$emit("update:detailVisible", false);

		},
		async getPushState(){
			if(this.id<=0) return false;
            let res=await api.getEvalPushState({evalId:this.id});
            if(res.code==1000){
                this.pushState=res.data.pushState
            }
        },
    // showDlg() {},
		// async onAssess() {
		// 	let questSuccess = true;
		// 	// 验证问卷是否已完成
		// 	this.questList?.map(item=>{
		// 		if (!item.finishTime) {
		// 			questSuccess = false;
		// 		}
		// 	})
		// 	if (!questSuccess) {
		// 		return this.$message.warning('请先完成评估问卷');
		// 	}
		// 	switch(this.customerEval.type) {
		// 		// 睡眠
		// 		case '7': this.assessForm7(); break;
		// 	}
		// },
		// async assessForm7() {
		// 	let res;
		// 	this.$refs['form7'].validate(async (valid)=>{
		// 		if (valid) {
		// 			this.form7.patientId = this.patientId;
		// 			this.form7.bmi = (this.form7.weight / (this.form7.height / 100) ** 2).toFixed(2);
		// 			res = await api.addPatientLabBasic(this.form7);
		// 			if (res.code != 1000) {return this.$message.error(res.message);}
		// 			res = await api.assessCustomerEval({id: this.id, params: {}});
		// 			if (res.code != 1000) {return this.$message.error(res.message);}
		// 			this.current = 2;
		// 		}
		// 	});
		// },
		// 评估成功回调方法
		onAssessSucc() {
			// 刷新当前详细数据
			this.loadData();
			// 刷新列表数据
			this.$emit("reload");
			// 刷新侧边栏数据
			this.$store.dispatch('loadSideEvalList');
		},
		exportPdf() {
			htmlToPdf.outPutPdfFn(document.querySelector('.step-2'), this.name);
		},		
	}
}
</script>

<style lang="less" scoped>
// @import './template.less';
.hisQuest{
	display: flex;
	align-items: center;
	position: absolute;
	right: 140px;
	color: #409EFF;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	img{
		width: 20px;
		height: 20px;
		margin-right: 4px;
	}
}	
.dialogWrap{
	position:fixed;
		left: 0;
		top:0;
		width: 100%;
		height: 100%;
		z-index: 2124;
	.modalmask{
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,.3);
	}
}
.eval-history-list{
	position: absolute;
    right: 20px;
    font-size: 16px;
    cursor: pointer;
}
.drawer-content {
	padding: 20px 0!important;
}
.step-1 {
	padding-top: 20px;
	
	.step-title {
		padding: 15px 30px;
		border-bottom: 1px solid #F6F6F6;
		display: flex;
		justify-content: space-between;

	}
	.step-content {
		margin-top: 30px;
		padding: 0 30px;
	}
}

/deep/.step-2 {
	padding: 0 30px;
	h3 {
		margin-bottom: 15px;
		padding-bottom: 5px;
		border-bottom: 2px solid #699CE4;
		color: #699CE4;
		font-size: 22px;
		font-weight: 400;
	}
	h4 {
		margin-bottom: 15px;
		padding-left: 20px;
		padding-bottom: 5px;
		border-left: 4px solid #699CE4;
		color: #699CE4;
		font-size: 20px;
		font-weight: 400;		
	}
	table {
		width: 100%;
		margin-bottom: 20px;
		border-collapse: collapse;
		td,th {
			border: 1px solid #aaa;
		}
		th {
			padding: 10px 0;
			background-color: #699CE4;
			color: #fff;
		}
		td {
			padding: 15px 10px;
		}
		span {
			color: #699CE4;
			font-size: 20px;
			text-align: center;
			display: block;
		}
	}
	.step-title {
		position: relative;
		padding: 50px 30px;
		font-size: 28px;
		text-align: center;
		display: inherit;
	}

	.support {
		margin-top: 40px;
		padding-top: 20px;
		border-top: 1px solid #bbb;
		text-align: right;
		span {
			padding-left: 30px;
			background: 0 50% url(../../../../../assets/images/sbk.png) no-repeat;
		}
	}

	.result-bar-wrap {
		position: relative;
		margin-top: 30px;
		padding: 56px 0 0;
		&.t2 {
			.c-0 { 
				left: 22%;
				&::after { border-bottom-color: #74AB60; }
			}
			.c-2 { 
				left: 75%;
				&::after { border-bottom-color: #D26B62; }
			}
			.t-0 {color: #74AB60;}
			.t-2 {color: #D26B62;}			
			.r-bar {
				background: linear-gradient(270deg, #D26B62 0%, #D26B62 40%, #74AB60 56%, #74AB60 99%);
			}
			.tab-1 {
				left: 22%;
				background-color: #74AB60;
				&::after {
					border-top-color: #74AB60;
				}
			}
			.tab-2 {
				left: 75%;
				background-color: #D26B62;
				&::after {
					border-top-color: #D26B62;
				}
			}
		}
		&.t3 {
			.c-0 { 
				left: 10%; 
				&::after { border-bottom-color: #74AB60; }
			}
			.c-1 { 
				left: 43%; 
				&::after { border-bottom-color: #FFC428; }
			}
			.c-2 { 
				left: 75%; 
				&::after { border-bottom-color: #D26B62; }
			}
			.t-0 {color:#74AB60 ;}
			.t-1 {color: #FFC428;}
			.t-2 {color: #D26B62;}

			.r-bar {
				background: linear-gradient(270deg, #D26B62 25%, #FFC60C 39%, #FFC247 60%, #74AB60 77%, #74AB60 90%);
			}
			.tab-0 {
				left: 10%;
				background-color: #74AB60;
				&::after {
					border-top-color: #74AB60;
				}
			}			
			.tab-1 {
				left: 43%;
				background-color: #FFC428;
				&::after {
					border-top-color: #FFC428;
				}
			}
			.tab-2 {
				left: 75%;
				background-color: #D26B62;
				&::after {
					border-top-color: #D26B62;
				}
			}			
		}

		.r-bar {
			height: 14px;
			margin-bottom: 30px;
			border-radius: 7px;
		}
		.tab-0, .tab-1, .tab-2 {
			position: absolute;
			top: 0;
			width: 84px;
			height: 38px;
			line-height: 38px;
			border-radius: 2px;
			color: #fff;
			font-size: 20px;
			text-align: center;
			&::after {
				position: absolute;
				left: 36px;
				top: 38px;
				border: 10px solid transparent;
				border-width: 10px 8px;
				content: '';
			}
		}
		.c-0, .c-1, .c-2 {
			position: absolute;
			bottom: 30px;
			width: 84px;
			&::after {
				position: absolute;
				left: 36px;
				bottom: 15px;
				border: 10px solid transparent;
				border-width: 10px 8px;
				content: '';
			}			
		}
	}
}

/deep/.exam-item {
	margin: 0 20px;
	padding: 30px 0 10px;

	.el-checkbox-group, .el-radio-group {
		font-size: 14px;
	}
	.item-name {
		margin-bottom: 20px;

		.date {
			color: #bbb;
			font-size: 14px;
			float: right;
		}
	}
	.opt-item {
		margin: 0 0 10px 2em;
		&:last-child {
			margin-bottom: 0;
		}
		.el-input {
			margin: 0 5px 0 20px;
		}
	}
	.date {
		color: #858585;
		font-size: 12px;
	}
	.el-icon-warning {
		color: #888;
	}
	.el-icon-success {
		color: #409EFF;
	}
}

.tb-item {
	.title {
		>div {
			&:first-child {
				flex: 1.5;
			}
		}
	}
	.tb-content {
		>div {
			&:first-child {
				flex: 1.62;
			}			
		}
	}
}

.sub-title {
		padding: 20px 30px;
		border-bottom: 1px solid #F6F6F6;
		display: flex;
		justify-content: space-between;
		position: relative;
	}
	.sub-content {
		margin-top: 30px;
		padding: 0 30px;
	}
</style>
